import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.palette.primary.background};
  padding: 20px 15px;
`;

export const Title = styled(Typography.Body)`
  color: ${({ theme }) => theme.palette.primary.labels};
  text-align: center;
  margin: 15px 0;
`;
